export const environment = {
  production: false,
  type: "serve", 
  title: "HKLSC Online Shop",
  baseHref: "/",
  version: require('../../package.json').version,
  versions: require('../../package.json').versions,
  serverHost: "https://dev-shop.hklsc.net/",
  apiUrl: "https://dev.hklsc.net/RainbowOne/index.php/PHPGateway2/proxy/2.8/",
  loginDomain: "hklsc",
  online_shop_tag_id: 70831,
  online_shop_school_id: 69199,
  blob_url: "https://okadev.blob.core.windows.net/media/",
  ro_path: "https://dev.hklsc.net/",
  qfpay_url: "https://test-openapi-hk.qfapi.com/checkstand/#/?",
  qfpay_appcode: "1B9B12BF2B524175BE53C3DA8304BAF6",
  qfpay_apikey: "59A80AA9AF9E4C0F9770464A04C590F9",
  oka_payment_gateway: 'http://lesson2.openknowledge.hk:8081/api',
  paypal_client_id: "AUJPQv4NBs0qAxjf2Gp97aUaIxm41wc7ZQ7yfN3iAqrhtTCclJgYm5yYcusKNjOeCxdOoscrrbP-EGAy",
}; 